export default "__VITE_ASSET__DbY_VlTj__"